import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
type Props = {
  label?: string;
};
export function Countdown({
  label = 'THE OFFER ENDS IN'
}: Props) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const min = Math.floor(remaining % 3600 / 60);
  const sec = remaining % 60;
  const cells: Array<[string, string]> = [[pad(hrs), 'HRS'], [pad(min), 'MIN'], [pad(sec), 'SEC']];
  return <div className="w-full" data-id="element-19" data-mp="3731jcmoa08bb">
      <p className="text-center text-[11px] font-bold uppercase tracking-[0.28em] text-flame-400" data-id="element-20" data-mp="10cbt5hb351es">
        {label}
      </p>
      <div className="mt-2 flex items-stretch justify-center gap-2" role="timer" aria-live="off" data-id="element-21" data-mp="15by41k3fy5kf">
        {cells.map(([value, unit]) => <div key={unit} className="min-w-[74px] rounded-lg border border-ink-500 bg-ink-800 px-3 py-2 text-center sm:min-w-[86px]" data-id="element-22" data-mp="xzbz7tiz49lk">
            <span className="block font-display text-3xl font-extrabold leading-none tabular-nums text-white sm:text-4xl" data-id="element-23" data-mp="17py874w6q1va">
              {value}
            </span>
            <span className="mt-1 block text-[10px] font-semibold uppercase tracking-[0.18em] text-zinc-500" data-id="element-24" data-mp="f2aum9tc0bi5">
              {unit}
            </span>
          </div>)}
      </div>
    </div>;
}